export default __webpack_public_path__ + "static/media/visaCardHd.61a1c135.svg";